<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <div class="date-picker-v2">
          <el-date-picker
            class="query-date-picker"
            v-model="queryParams.month"
            type="monthrange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            :range-separator="$t('rangeSeparator')"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            @change="search"
          />
        </div>
        <div class="input-v2">
          <select-cus @change="cusChange"></select-cus>
        </div>
        <div class="input-v2 ml16">
          <el-input class="input-v2 prefix-primary-color" placeholder="姓名" suffix-icon="el-icon-search" v-model="queryParams.empName" clearable></el-input>&nbsp;&nbsp;&nbsp;
        </div>
        <div class="input-v2 ml16">
          <el-button type="primary" class="button-v2" @click="getData">查询</el-button>
        </div>
      </div>
      <div class="title-right">
        <el-button type="primary" class="button-v2" @click="exportExcel">导出</el-button>
      </div>
    </div>
    <div class="table-body flex vertical" style="height: calc(100vh - 234px);">
      <air-table
        ref="airTable"
        class="table-v2"
        align="center"
        :columns="columns"
        :data="tableData"
        @change-filter="changeFilter"
        :showOperation="false"
        :show-checkbox="false"
      >
      </air-table>
      <bsp-pagination :pager-config.sync="queryParams" @page-change="pageChange" @page-size-change="pageSizeChange" show-page-size />
    </div>
  </div>
</template>
<script>
  import {getLoadBatchDataForHr,exportExcleHR} from "@/api/merit/ruichen.js"
  import SelectCus from '@/views/v2/stats/data-center/components/Common/SelectCus';
  import {downloadFile} from "@/util/util";
  import { validatenull } from '@/util/validate';
  
  export default {
    name: 'MeritDetailsForHR',
    created() {
      this.getData()
    },
    components: {
      SelectCus
    },
    data() {
      return {
        branchId:this.$route.query.batchId,
        importDate:this.$route.query.importDate,
        queryParams: {
          month:[],
          cusIds:[],
          batchName:'',
          id:'',
          empName:'',
          page: 1,
          limit: 20,
          total: 0
        },
        change:'1',
        addUpload: false,
        checkNoCefirmFlag: false,
        noCefirm: [],
        sum: '',
        columns: [],
        tableData: [],
        multipleSelection: []
      }
    },
    methods: {
      pageChange({ type, currentPage, pageSize }) {
        if (type == 'size') {
          this.queryParams.page = 1;
        }
        this.getData();
      },
      // 分页输入框回车，调接口
      pageSizeChange(val) {
        this.queryParams = Object.assign(val);
        this.getData();
      },
      changeFilter(e) {
        this.queryParams = {...this.queryParams, ...e.filterData};
        this.getData();
      },
      handleSelectionChange({records}) {
        this.multipleSelection = records;
      },
      
      // 初始化数据
      getData() {
        let params = {
            pageNum: '2',
            ...this.queryParams
        }
        getLoadBatchDataForHr(params).then(res=>{
          this.tableData = res.data.records
          this.columns = res.data.condition.columns
          this.queryParams.total = parseInt(res.data.total)
        })
      },
      // 删除
      handleDelete(row) {
      
      },
      // 客户筛选change事件
      cusChange({ data, checkedLabels, checkedValues }) {
        this.queryParams.cusIds = checkedValues;
        this.getData();
      },
      // 导出
      exportExcel() {
        exportExcleHR(this.queryParams).then(res=> {
          downloadFile(res)
        })
      }
    }
  }
</script>
